<!--
 * @Author: ext.shuiqianning1
 * @Date: 2022-04-24 14:20:44
 * @LastEditors: zhanggaoyuan6 zhanggaoyuan6@jd.com
 * @LastEditTime: 2023-11-23 11:39:15
 * @FilePath: /content-center/src/entrys/man/pages/wikiManage/commonwiki/index.vue
 * @Description:
-->
<!-- 疫苗分类-->
<!-- <check-box-class :isCheckBoxClass="false" ref="vaccineLabelref" :functionIds="{queryVaccineCategories: 'health_cmp_biz_queryVaccineCategories'}" @checkoutVaccineLabel="checkoutVaccineLabel" /> -->
<template>
  <div class="article">
    <!-- 当前位置 -->
    <bread-crumb></bread-crumb>
    <div class="wrap">
      <!-- title  id和name  -->
      <div v-for="item in floorTransferDTOS" :key="item.floorLabelCode">
        <audit-info
          actionType="17"
          :contentId="form.contentId"
          :contentName="form.contentName"
          v-if="item.floorLabelCode === 'common-wiki-name-id'"
        />
        <div
          class="c-title-wrap"
          v-if="item.floorLabelCode === 'common-wiki-name-id'"
        >
          <p class="c-title">基本内容</p>
        </div>
        <!-- 别名 -->
        <div v-if="item.floorLabelCode === 'common-wiki-alias'">
          <div v-for="val in item.cfgList" :key="val.name">
            <div v-if="val.name === 'submit'">
              <contentAlias-Names
                :commonData="JSON.parse(val.value)"
                :aliasName.sync="form.contentAliasNames"
              />
            </div>
          </div>
        </div>

        <!-- 功效 -->
        <div v-if="item.floorLabelCode === 'common-wiki-peteffect'">
          <div v-for="val in item.cfgList" :key="val.name">
            <div v-if="val.name === 'submit'">
              <pet-effect
                ref="PetEffect"
                :commonData="JSON.parse(val.value)"
                @petEffect="petEffect"
                :petEffectCode="petEffectCode"
              />
            </div>
          </div>
        </div>
        <!-- 分类 -->
        <div v-if="item.floorLabelCode === 'common-wiki-classify'">
          <div v-for="val in item.cfgList" :key="val.name">
            <div v-if="val.name === 'submit'">
              <Classify
                ref="petClassify"
                :commonData="JSON.parse(val.value)"
                @petChange="petChange"
                :petClassifyCode="petClassifyCode"
                :type="$route.query.type"
              />
            </div>
          </div>
        </div>

        <!-- 易感动物 -->
        <div v-if="item.floorLabelCode === 'common-wiki-symptoms'">
          <div v-for="val in item.cfgList" :key="val.name">
            <div v-if="val.name === 'submit'">
              <ContentPetSymptoms
                ref="ContentPetSymptoms"
                :commonData="JSON.parse(val.value)"
                @petSymptoms="petSymptoms"
                :petSymptomsCode="petSymptomsCode"
              />
            </div>
          </div>
        </div>

        <!-- 宠物药品 -->
        <div v-if="item.floorLabelCode === 'common-wiki-petdrug'">
          <div v-for="val in item.cfgList" :key="val.name">
            <div v-if="val.name === 'submit'">
              <DrugClassify
                ref="PetDrug"
                :commonData="JSON.parse(val.value)"
                @petChageDrug="petChageDrug"
                :petDrugClassifyCode="petDrugClassifyCode"
              />
            </div>
          </div>
        </div>

        <!-- 剂型 -->
        <div v-if="item.floorLabelCode === 'common-wiki-typedrug'">
          <div v-for="val in item.cfgList" :key="val.name">
            <div v-if="val.name === 'submit'">
              <PetDrugType
                ref="PetDrugType"
                :commonData="JSON.parse(val.value)"
                @petChageDrugType="petChageDrugType"
                :petDrugTypeClassifyCode="petDrugTypeClassifyCode"
              />
            </div>
          </div>
        </div>

        <!-- 是否宠物处方药 -->
        <div v-if="item.floorLabelCode === 'common-wiki-isrx'">
          <div v-for="val in item.cfgList" :key="val.name">
            <div v-if="val.name === 'submit'">
              <IsRx :commonData="JSON.parse(val.value)" :rxType.sync="rxType" />
            </div>
          </div>
        </div>

        <!-- 传染病 -->
        <div v-if="item.floorLabelCode === 'common-wiki-infectious'">
          <div v-for="val in item.cfgList" :key="val.name">
            <div v-if="val.name === 'submit'">
              <infectious-mark
                :commonData="JSON.parse(val.value)"
                :infectiousMark.sync="form.diseaseInfo.infectiousMark"
              />
            </div>
          </div>
        </div>

        <!-- 药品分类 -->
        <div v-if="item.floorLabelCode === 'common-wiki-category'">
          <div v-for="val in item.cfgList" :key="val.name">
            <div v-if="val.name === 'submit'">
              <category-drugs
                ref="categoryDrugsRef"
                :functionIds="{
                  queryDrugCategoryWithRel:
                    'health_cmp_biz_queryDrugCategoryWithRel',
                }"
                @checkCateGoryLabel="checkCateGoryLabel"
                :commonData="JSON.parse(val.value)"
                :contentId="form.contentId"
              />
            </div>
          </div>
        </div>
        <!-- 是否为处方药 -->
        <div v-if="item.floorLabelCode === 'common-wiki-prescription'">
          <prescription-drugs :prescriptionDrug.sync="prescriptionDrug" />
        </div>
        <!-- 疫苗分类-->
        <div v-if="item.floorLabelCode === 'common-wiki-vaccine-category'">
          <div v-for="val in item.cfgList" :key="val.name">
            <div v-if="val.name === 'submit'">
              <check-vaccines-class
                ref="vaccineLabelref"
                :commonData="JSON.parse(val.value)"
                :functionIds="{
                  queryVaccineCategories:
                    'health_cmp_biz_queryVaccineCategories',
                }"
                @checkoutVaccineLabel="checkoutVaccineLabel"
              />
            </div>
          </div>
        </div>
        <!-- 中药作用 -->
        <div v-if="item.floorLabelCode === 'wiki-detail-effect'">
          <div v-for="val in item.cfgList" :key="val.name">
            <div v-if="val.name === 'submit'">
              <effect-selected
                :commonData="JSON.parse(val.value)"
                :contentChineseMedicine.sync="contentChineseMedicine"
              />
            </div>
          </div>
        </div>
        <!-- 付费情况 -->
        <div v-if="item.floorLabelCode === 'common-wiki-payment'">
          <div v-for="val in item.cfgList" :key="val.name">
            <div v-if="val.name === 'submit'">
              <payment
                :value.sync="form.contentVaccine.payType"
                :commonData="JSON.parse(val.value)"
              />
            </div>
          </div>
        </div>
        <!-- 接种几针 -->
        <div v-if="item.floorLabelCode === 'common-wiki-inoculation-num'">
          <inoculationNum :value.sync="form.contentVaccine.vaccinationCount" />
        </div>
        <!--选择疾病 多选-->
        <div v-if="item.floorLabelCode === 'common-wiki-select-disease'">
          <div v-for="val in item.cfgList" :key="val.name">
            <div v-if="val.name === 'submit'">
              <SelectDiseases
                :commonData="JSON.parse(val.value)"
                ref="selectDiseaseRef"
                :contentId="form.contentId"
              />
            </div>
          </div>
        </div>
        <!--选择疾病方向 多选 （本期先不做）-->
        <!-- <div v-if="item.floorLabelCode === 'common-wiki-select-direction'">
          <div v-for="val in item.cfgList" :key="val.name">
            <div v-if="val.name === 'submit'">
              <DiseaseDirection
                :commonData="JSON.parse(val.value)"
                ref="selectDirectionRef"
                :contentId="form.contentId"
              />
            </div>
          </div>
        </div> -->
        <!-- 部位 -->
        <div v-if="item.floorLabelCode === 'common-wiki-select-location'">
          <div v-for="val in item.cfgList" :key="val.name">
            <div v-if="val.name === 'submit'">
              <symptoms-parts
                ref="symptomsPartsRef"
                :commonData="JSON.parse(val.value)"
                :symptomsPartsValue.sync="symptomsPartsValue"
              />
            </div>
          </div>
        </div>
        <!-- 建议科室 -->
        <div v-if="item.floorLabelCode === 'common-wiki-department'">
          <div v-for="val in item.cfgList" :key="val.name">
            <div v-if="val.name === 'submit'">
              <div class="flex align-items-center department-item one">
                <p>
                  <span
                    class="red"
                    v-if="JSON.parse(JSON.parse(val.value)[1].value) === '1'"
                    >*</span
                  >建议科室
                </p>
                <el-cascader
                  placeholder="请选择科室"
                  :value="selectedDeparttId"
                  :options="departmentList"
                  :props="departmentProps"
                  @change="changeDepartment"
                  :show-all-levels="false"
                  ref="cascader"
                ></el-cascader>
              </div>
            </div>
          </div>
        </div>
        <!-- 关联疾病百科 -->
        <div v-if="item.floorLabelCode === 'common-wiki-relevance-diseases'">
          <div v-for="val in item.cfgList" :key="val.name">
            <div v-if="val.name === 'submit'">
              <contentLabel-cp
                :commonData="JSON.parse(val.value)"
                :data="form.contentRelations"
                @changeDiseaseLabels="changeDiseaseLabels"
                :is-show-disease="isShowDisease"
                :actionType="actionType"
                :functionIds="{ queryContents: 'health_cmp_queryContents' }"
              />
            </div>
          </div>
        </div>
        <!-- 关联药品 -->
        <div v-if="item.floorLabelCode === 'common-wiki-seldrugs'">
          <div v-for="val in item.cfgList" :key="val.name">
            <div v-if="val.name === 'submit'">
              <select-encyclopedia
                :data="form.contentDrugs"
                @changeEncyclopediaLabels="changeEncyclopediaLabels"
                :is-show-encyclopedia="isShowEncyclopedia"
                :functionIds="{
                  queryEncyclopedia: 'health_cmp_biz_manPageDrugInfoByParam',
                }"
              ></select-encyclopedia>
            </div>
          </div>
        </div>
        <!-- 项目简介-->
        <div v-if="item.floorLabelCode === 'common-wiki-project-introduction'">
          <div v-for="val in item.cfgList" :key="val.name">
            <div v-if="val.name === 'submit'">
              <project-introduction
                :commonData="JSON.parse(val.value)"
                :projectIntroduction.sync="form.summary"
              />
            </div>
          </div>
        </div>
        <!-- 项目功效 -->
        <div v-if="item.floorLabelCode === 'common-wiki-project-effectiveness'">
          <div v-for="val in item.cfgList" :key="val.name">
            <div v-if="val.name === 'submit'">
              <project-effectiveness
                :commonData="JSON.parse(val.value)"
                ref="projectEffectivenessRef"
              />
            </div>
          </div>
        </div>
        <!-- 百科段落 -->
        <div v-if="item.floorLabelCode === 'common-wiki-paragraph'">
          <div v-for="val in item.cfgList" :key="val.name">
            <div v-if="val.name === 'submit'">
              <paragraph
                :commonData="JSON.parse(val.value)"
                :paragraphList="paragraphList"
                :editorReady="editorReady"
                :blurEditorEvent="blurEditorEvent"
                :editorChange="editorChange"
              />
            </div>
          </div>
        </div>
        <!-- 参考文献 -->
        <div
          v-if="
            item.floorLabelCode === 'common-wiki-paragraph' &&
            actionType != 37 &&
            actionType != 42
          "
          class="content-item flex textArea-flex"
          style="position: relative"
        >
          <div class="content-item-label">参考文献</div>
          <c-editor
            :content="form.referenceEditorContent"
            @blurEditorEvent="blurEditorEvent"
          ></c-editor>
        </div>
        <!-- 多图 -->
        <div
          v-if="item.floorLabelCode === 'common-wiki-multiimg'"
          class="image-container"
          style="position: relative"
        >
          <div class="image-flex">
            <div
              v-for="(item, index) in form?.contentPictures"
              :key="index"
              class="image-item"
            >
              <img
                :src="
                  item?.url.startsWith('https://storage.360buyimg.com') ||
                  item?.url.startsWith('http://storage.jd.local') ||
                  item?.url.startsWith('https') ||
                  item?.url.startsWith('http') ||
                  item?.url.startsWith('https://jkimg10.360buyimg.com') ||
                  item?.url.startsWith('https://storage.360buyimg.com')
                    ? item?.url
                    : `${'https://img10.360buyimg.com/imagetools/'}${item?.url}`
                "
                alt="图片"
                @click="handleImageClick(item?.url)"
              />
              <div class="image-overlay">
                <el-button
                  @click="
                    viewImage(
                      item?.url.startsWith(imgHost) ||
                        item?.url.startsWith('http://storage.jd.local') ||
                        item?.url.startsWith('https') ||
                        item?.url.startsWith('http') ||
                        item?.url.startsWith('https://jkimg10.360buyimg.com') ||
                        item?.url.startsWith('https://storage.360buyimg.com')
                        ? item?.url
                        : `${'https://img10.360buyimg.com/imagetools/'}${
                            item?.url
                          }`
                    )
                  "
                  type="primary"
                  icon="el-icon-zoom-in"
                  size="mini"
                ></el-button>
              </div>
            </div>
          </div>
        </div>
        <!--标签-->
        <content-label
          v-if="item.floorLabelCode === 'common-wiki-checkbox'"
          ref="contentLabelref"
          :isContentLabels="false"
          :functionIds="{
            listTenantContentLabels: 'health_cmp_biz_pageAuditLabels',
          }"
          @checkArticleLabel="checkArticleLabel"
        />
        <!-- 通用标签 -->
        <div
          class="c-title-wrap"
          v-if="item.floorLabelCode === 'common-wiki-auditlabels'"
        >
          <p class="c-title">标签信息</p>
        </div>
        <div
          v-if="item.floorLabelCode === 'common-wiki-auditlabels'"
          class="content-item flex align-items-center"
        >
          <question-cascader
            :id="form.contentId"
            ref="questionLabel"
          ></question-cascader>
        </div>
        <div
          v-if="item.floorLabelCode === 'common-wiki-auditlabels'"
          class="image-container"
          style="position: relative"
        >
          <article-label
            :articleId="form.contentId"
            :functionIds="{ getArticleLabel: 'health_cmp_biz_pageAuditLabels' }"
            ref="labelRef"
          />
        </div>
        <div
          v-if="item.floorLabelCode === 'common-wiki-auditlabels'"
        >
        <!-- 商品标签 -->
          <content-skus-label :data="form.contentSkus" @changeContentSkusLabels="changeContentSkusLabels"
            :functionIds="{ getContentSkus: 'health_cmp_biz_querySkus' }" />
        </div>
        <!--关键词-->
        <div v-if="item.floorLabelCode === 'common-wiki-key-word'">
          <div v-for="val in item.cfgList" :key="val.name">
            <div v-if="val.name === 'submit'">
              <keywords
                :commonData="JSON.parse(val.value)"
                :keyWordsShow="false"
                ref="keywordsref"
              />
            </div>
          </div>
        </div>
        <!-- 编写医生 -->
        <div v-if="item.floorLabelCode === 'common-wiki-compile-doctor'">
          <div v-for="val in item.cfgList" :key="val.name">
            <div v-if="val.name === 'submit'">
              <div class="writeDoc flex content-item department-item">
                <p>
                  <span
                    class="red"
                    v-if="JSON.parse(JSON.parse(val.value)[0].value) === '1'"
                    >*</span
                  >编写医生
                </p>
                <el-select
                  v-model="writeDoctor"
                  filterable
                  placeholder="请选择"
                  size="mini"
                  class="selectBus"
                  remote
                  :remote-method="write_remoteMethod"
                  :loading="write_doctor_loading"
                  @change="writeChange"
                  clearable
                >
                  <el-option
                    v-for="(item, index) in writeOptions"
                    :key="index"
                    :label="
                      item.docName +
                      '  ' +
                      item.titleName +
                      '  ' +
                      item.hospitalGradeName +
                      '  ' +
                      item.hospitalName +
                      '  ' +
                      item.departName
                    "
                    :value="item.docId"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>
        </div>
        <!--编审医生-->
        <div v-if="item.floorLabelCode === 'common-wiki-editorial-doctor'">
          <div v-for="val in item.cfgList" :key="val.name">
            <div v-if="val.name === 'submit'">
              <write-doctor
                :commonData="JSON.parse(val.value)"
                :isFlag="true"
                :flag="true"
                :isWriteDoctor="true"
                :writeDoctor.sync="doctor"
                :writeOptions="doctorOptions"
                :write_doctor_loading="search_doctor_loading"
                @write_remoteMethod="doctor_remoteMethod"
                @writeChange="writeChange"
              />
            </div>
          </div>
        </div>
        <!-- 编审人员 -->
        <div v-if="item.floorLabelCode === 'common-wiki-editors-and-reviewers'">
          <div v-for="val in item.cfgList" :key="val.name">
            <div v-if="val.name === 'submit'">
              <editorial-personnel
                :commonData="JSON.parse(val.value)"
                :form="form"
              />
            </div>
          </div>
        </div>
        <!-- 编写药师 -->
        <div v-if="item.floorLabelCode === 'common-wiki-write-doctor'">
          <write-doctors
            :writeDoctor.sync="doctor"
            :writeOptions="doctorOptions"
            :write_doctor_loading="search_doctor_loading"
            @write_remoteMethod="doctor_remoteMethod"
            @writeChange="writeChange"
            :isFlag="true"
            :Pharmacist="1"
          ></write-doctors>
        </div>
      </div>
    </div>

    <div class="finish-btns">
      <el-button
        type="primary"
        @click="manOrUpdateDiseaseInfo(2, 'through')"
        v-if="auditInfoShow == 2"
        ><span>通过</span></el-button
      >
      <el-button @click="rejectClick" v-if="auditInfoShow == 2">
        <span>驳回</span>
      </el-button>
      <el-button
        @click="manOrUpdateDiseaseInfo(1, 'save')"
        v-if="auditInfoShow == 2 ? false : auditInfoShow == 3 ? false : true"
      >
        <span>保存</span>
      </el-button>
      <el-button
        @click="manOrUpdateDiseaseInfo(2, 'manSubmit')"
        v-if="auditInfoShow !== 2"
      >
        <span>提交</span>
      </el-button>
      <el-button
        v-if="this.actionType != 37 && this.actionType != 42"
        @click="manOrUpdateDiseaseInfo(0, 'manPreview')"
      >
        <span>预览</span>
      </el-button>
    </div>
    <!-- ===================== 预览弹窗 ====================== -->
    <preview-modal
      :mUrl.sync="mUrl"
      :dialogPreVisible.sync="dialogPreVisible"
      :qrCode="qrCode"
    />

    <!-- ===================== 驳回弹窗 ====================== -->
    <reject-modal
      :rejectForm.sync="rejectForm"
      @rejectClickHandler="rejectClickHandler"
    />

    <modal
      :isShow.sync="deleteForm.deleteDialog"
      title="删除"
      :isShowBtn="deleteForm.isShowBtn"
      :btnText="deleteForm.btnText"
      @clickHandler="deleteClickHandler"
    >
      <div class="dialogVal">需要删除所有疾病百科信息吗？</div>
    </modal>

    <modal
      :isShow.sync="reset_Diseases"
      title="更换疾病名称"
      :btnText="[]"
      :isShowBtn="[]"
      :width="'400px'"
      @clickHandler="repealclickHandler"
    >
      <div class="dialogVal">更改疾病将清空已填疾病的所有内容，是否继续?</div>
    </modal>
    <!-- 图片放大展示 -->
    <el-dialog :visible.sync="dialogVisible" width="50%">
      <img :src="currentImageUrl" alt="图片" style="width: 100%" />
    </el-dialog>
  </div>
</template>
<script>
import breadCrumb from "@/components/wiki/breadCrumb";
import modal from "@/components/modal";
import CEditor from "@/components/editor/CEditor";
// import CheckBoxClass from "@/components/wiki/CheckBoxClass.vue";
// import payment from "@/components/radio/payment.vue";
// import inoculationNum from "@/components/radio/inoculationNum.vue";
// import contentLabelCp from "@/components/tag/contentLabelCp";
import PreviewModal from "@/components/pop/PreviewModal";
import RejectModal from "@/components/pop/RejectModal";
import contentAliasNames from "@/components/wiki/contentAliasNames";
import Keywords from "@/components/wiki/Keywords";
import WriteDoctor from "@/components/wiki/WriteDoctor";
import ContentLabel from "@/components/wiki/ContentLabel";
import ArticleLabel from "@/components/select/ArticleLabel";
import ContentSkusLabel from '@/components/combination/ContentSkusLabel';
import AuditInfo from "@/components/wiki/AuditInfoBaike";
import EditorialPersonnel from "@/components/wiki/EditorialPersonnel";
import paragraph from "@/components/wiki/paragraphList";
import EffectSelected from "@/components/wiki/effectSelected";
import SelectDiseases from "@/components/wiki/SelectDiseases";
import DiseaseDirection from "@/components/wiki/DiseaseDirection";
import SymptomsParts from "@/components/wiki/SymptomsParts";
import contentLabelCp from "@/components/wiki/contentLabelCp";
import InfectiousMark from "@/components/wiki/InfectiousMark";
import CategoryDrugs from "@/components/wiki/CategoryDrugs";
import PrescriptionDrugs from "@/components/wiki/PrescriptionDrugs";
import SelectEncyclopedia from "@/components/wiki/SelectEncyclopedia";
import WriteDoctors from "@/components/wiki/WriteDoctors";
import CheckVaccinesClass from "@/components/wiki/CheckVaccinesClass.vue";
import payment from "@/components/wiki/payment.vue";
import inoculationNum from "@/components/wiki/inoculationNum.vue";
import QuestionCascader from "@/components/select/QuestionCascader";

import ProjectIntroduction from "@/components/wiki/ProjectIntroduction";
import ProjectEffectiveness from "@/components/wiki/ProjectEffectiveness";

// import EditorialPersonnel from "@/components/wiki/EditorialPersonnel";
import Classify from "@/components/wiki/Classify";
import ContentPetSymptoms from "@/components/wiki/contentPetSymptoms";
import DrugClassify from "@/components/wiki/drugClassify";
import PetDrugType from "@/components/wiki/petdrugType";
import IsRx from "@/components/wiki/isRx";
import PetEffect from "@/components/wiki/petEffect";

import { getQRCode } from "@/utils/tools";
import { request } from "@/utils/axios";

import utils from "@/utils";

const baseUrl = process.env.VUE_APP_BASEURL;

export default {
  data() {
    return {
      // 失去焦点编辑器保存提示成功时间，定时清除提示
      tipTimeout: null,
      //疾病搜索
      loading: false,
      diseaseInfoOptions: [],
      isShowEncyclopedia: false,
      //结束疾病搜索
      reset_Diseases: false, // 修改关联疾病名称
      //科室

      departmentList: [],
      writeDoctor: "",
      departmentProps: {
        multiple: true,
        checkStrictly: true,
        value: "departId",
        label: "departName",
        children: "departmentDTOList",
      },
      selectedDeparttId: [],
      //结束科室
      paragraphList: [], // 段落
      paragraphListCategory: [],
      editorList: {},
      //结束编辑器相关
      // 编审医生
      search_doctor_loading: false,
      doctorOptions: [],
      doctor: "",
      actionType: "",
      user_identity: 0, // 身份信息
      infectiousMark: "", // 是否传染病
      baseUrl,
      selectedDeparttIdLength: 0,
      // 疾病百科信息集合
      // 宠物分类
      petClassifyCode: [],
      // 易感动物
      petSymptomsCode: [],
      // 宠物药品分类
      petDrugClassifyCode: [],
      // 宠物剂型分类
      petDrugTypeClassifyCode: [],
      form: {
        departments: [],
        diseaseInfo: {},
        contentAliasNames: [],
        contentRelations: [], // 关联的其他内容 仅需要id和type
        contentId: undefined, // 内容基本信息id
        //contentSkus: null, // 商品
        tenantId: Number(this.$commonJs.getTenantId()), // 租户id
        contentName: "", // 内容名称
        aliasName: [], // 别名
        englishName: undefined, // 英文名
        pinyinFirstLetter: undefined, // 拼音首字母
        contentType: undefined, // 疾病类型 默认8疾病百科 9疾病百科
        contentStatus: null, // 内容状态 1 上线 2下线
        auditInfo: {}, // 审核信息
        contentLabels: [], // 标签信息
        contentParagraphs: [], // 段落信息
        contentUsers: [], // 内容关联的用户
        keywordInfos: [], // 内容关键词
        contentEfficacys: [], // 项目功效
        doctorInfos: [], // 关联的医生
        // editreviewType:null, // 编审类型 1 平台医生 2 黄页医生
        contentAuditStatus: 1, // 内容审核状态1草稿、2待审核、3审核通过、4驳回
        contentDiseases: [],
        contentDiseaseDirections: [],
        bodyParts: [], // 部位值
        summary: "", // 项目介绍
        authors: [
          {
            authorType: "6",
            authorName: "",
          },
        ],
        infectiousMark: "", // 是否传染病
        drugCategories: [], // 药品分类
        contentAttributes: [], // 百科属性
        contentDrugs: [], // 关联药品
        contentVaccine: {
          // 疫苗
          vaccineCategories: [],
          vaccinationCount: "",
          payType: 1,
        },
        contentChineseMedicine: {}, // 作用
        contentPets: [],
        contentPetSymptoms: [],
        // 宠物药品
        contentPetMedicines: [],
        // 参考文献
        referenceEditorContent: "",
        // 多图
        contentPictures: [],
      },
      contentChineseMedicine: "",
      vaccineCategories: [],
      prescriptionDrug: 0, // 是否为处方
      isShowBtn: [false, false],
      dialogPreVisible: false,
      rejectForm: {
        rejectlineDialog: false,
        rejectReasons: "",
        isShowBtn: [true, true], //弹窗是否能显示按钮
        ordinaryBtnText: ["取消", "确认"],
      },
      // 删除弹框
      deleteForm: {
        deleteDialog: false,
        btnText: ["不删除", "删除"],
        isShowBtn: [true, true, false],
      },
      isShowDisease: false,
      symptomsPartsValue: [], // 部位值
      auditInfoShow: "",
      contentStatus: "",
      mUrl: "",
      writeOptions: [],
      floorTransferDTOS: [],
      // 宠物药品分类
      drugCategoryCode: "",
      // 宠物药品剂型
      dosageCode: "",
      // 是否处方
      rxType: "",
      // 宠物疾病code
      categoryCode: "",
      currentImageUrl: "",
      dialogVisible: false,
    };
  },
  components: {
    inoculationNum,
    payment,
    CheckVaccinesClass,
    PrescriptionDrugs,
    SelectEncyclopedia,
    CategoryDrugs,
    InfectiousMark,
    modal,
    breadCrumb,
    // contentLabelCp,
    CEditor,
    RejectModal,
    contentAliasNames,
    Keywords,
    PreviewModal,
    WriteDoctors,
    // inoculationNum,
    // payment,
    // CheckBoxClass,
    contentLabelCp,
    WriteDoctor,
    ContentLabel,
    ArticleLabel,
    ContentSkusLabel,
    QuestionCascader,
    AuditInfo,
    EditorialPersonnel,
    paragraph,
    SelectDiseases,
    DiseaseDirection,
    SymptomsParts,
    ProjectIntroduction,
    ProjectEffectiveness,
    EffectSelected,

    // EditorialPersonnel,
    Classify,
    ContentPetSymptoms,
    DrugClassify,
    PetDrugType,
    PetEffect,
    IsRx,
  },
  async created() {
    //获取科室
    if (this.$route.query.id) {
      this.form.contentId = this.$route.query.id;
    }
    if (this.$route.query.type) {
      this.actionType = this.$route.query.type;
    }

    this.selectDiseaseInfoId = [];
  },
  async mounted() {
    Array.prototype.diff = function (a) {
      return this.filter(function (i) {
        return a.indexOf(i) < 0;
      });
    };
    if (window.history && window.history.pushState) {
      history.pushState(null, null, document.URL);
      window.addEventListener("popstate", this.cancel, false);
    }
    await request("jdh_laputa_queryFloorList", {
      functionId: "manDetails" + this.actionType || this.$route.query.type,
      appId: "21557c5d3d0a4ec1b0184719022bb4b5",
      osName: "jdhwiki",
      venderId: null,
      inquiryTenancyId: null,
      version: 3,
    })
      .then(async (res) => {
        this.floorTransferDTOS = res?.cf?.floorTransferDTOS;
        await this.queryDepartments();
        await this.getContentParagraphDictionary();
      })
      .catch((err) => {
        this.$message.error(err.msg || "查询失败");
      });
    await this.init();
    this.$nextTick(() => {
      if (this.$refs.symptomsPartsRef) {
        this.$refs.symptomsPartsRef[0].getSymptomsParts();
      }
    });
    // 加载药品分类
    this.$nextTick(async () => {
      (await this.$refs.categoryDrugsRef) &&
        this.$refs.categoryDrugsRef[0].queryDrugCategoryWithRel(
          this.form.contentId || ""
        );
    });
    // await this.getContentParagraphDictionary();
    // 获取疫苗分类
    // await this.$refs.vaccineLabelref.queryVaccineCategories();
    //获取段落
    await this.getDiseaseInfoDraftDetail();
    // console.log(this.$refs.contentLabelref, 'this.$refs.contentLabelref');
    this.$nextTick(async () => {
      (await this.$refs.contentLabelref) &&
        this.$refs.contentLabelref[0].listTenantContentLabels();
    });
    //获取标签
    // 点击空白地方，文章内容存到缓存里面，当刷新页面的时候能够回显
    var flag = true;
    var isjqTri = false;
    var selectRoleSetTimeout;
    $("#selectRole")
      .on("compositionstart", function () {
        flag = false;
      })
      .on("compositionend", function () {
        flag = true;
      })
      .on("input", function (e) {
        clearTimeout(selectRoleSetTimeout);
        if (!this.loading)
          selectRoleSetTimeout = setTimeout(function () {
            if (flag && !isjqTri) {
              isjqTri = true;
            } else {
              isjqTri = false;
            }
          }, 100);
      });
    let that = this;
    //改写el函数
    if (this.$refs?.cascader?.length > 0) {
      this.$refs.cascader[0].computePresentTags = function () {
        const { isDisabled, leafOnly, showAllLevels, separator, collapseTags } =
          this;
        const checkedNodes =
          this.getCheckedNodes && this.getCheckedNodes(leafOnly);
        const tags = [];
        const genTag = (node) => ({
          node,
          key: node?.uid,
          text: node?.getText(showAllLevels, separator) || "",
          hitState: false,
          closable: !isDisabled && !node?.isDisabled,
        });
        if (checkedNodes?.length) {
          if (collapseTags) {
            tags.push({
              key: -1,
              text: `+ ${checkedNodes.length}`,
              closable: false,
            });
          } else {
            that.selectedDeparttId.forEach((item, index) => {
              const nodeItem = checkedNodes.filter((nodeItem) => {
                //匹配菜单层级
                if (
                  item.length == nodeItem.level &&
                  nodeItem.value == item[item.length - 1]
                )
                  return nodeItem;
              });
              tags.push(genTag(nodeItem[0]));
            });
          }
        }
        this.checkedNodes = checkedNodes;
        this.presentTags = tags;
      };
      this.$refs.cascader[0]?.computePresentTags.call(this.$refs.cascader);
    }
  },
  destroyed() {
    window.removeEventListener("popstate", this.cancel, false);
    // 移除段落缓存
    sessionStorage.removeItem("cache_articles");
  },
  methods: {
    // 宠物药品剂型
    petChageDrugType(obj) {
      let arr = [];
      this.petDrugTypeClassifyCode = obj.value;
      // console.log("petClassifyCode",this.petClassifyCode);
      // obj.value.forEach(item => {
      //   obj.list.forEach(it => {
      //     if(item == it.code) {
      //       arr.push({
      //         symptomCategoryCode: it.code,
      //         symptomCategoryDesc: it.desc
      //       })
      //     }
      //   })
      // });
      this.dosageCode = obj.value;
    },
    // 宠物药品分类
    petChageDrug(obj) {
      let arr = [];
      this.petDrugClassifyCode = obj.value;
      // console.log("petClassifyCode",this.petClassifyCode);
      // obj.value.forEach(item => {
      //   obj.list.forEach(it => {
      //     if(item == it.code) {
      //       arr.push({
      //         symptomCategoryCode: it.code,
      //         symptomCategoryDesc: it.desc
      //       })
      //     }
      //   })
      // });
      this.drugCategoryCode = obj.value;
    },
    // 宠物分类
    petChange(obj) {
      let arr = [];
      if (this.$route.query.articleType == 32) {
        this.petClassifyCode = obj.value;
        obj.list.forEach((it) => {
          if (obj.value == it.code) {
            arr.push({
              symptomCategoryCode: it.code,
              symptomCategoryDesc: it.desc,
            });
          }
        });
        this.form.contentPetSymptoms = arr;
      } else {
        this.categoryCode = obj.value;
      }
    },
    // 易感动物
    petSymptoms(obj) {
      let arr = [];
      this.petClassifyCode = obj.value;
      if (obj.value) {
        obj.value.forEach((item) => {
          obj.list.forEach((it) => {
            if (item == it.code || it.petCategoryCode) {
              arr.push({
                petCategoryCode: it.code || it.petCategoryCode,
                petCategoryDesc: it.desc || it.petCategoryDesc,
              });
            }
          });
        });
      } else {
        arr = obj.list;
      }

      this.form.contentPets = arr;
    },

    // 宠物功效
    petEffect(obj) {
      let arr = [];
      this.petClassifyCode = obj.value;
      obj.value.forEach((item) => {
        obj.list.forEach((it) => {
          if (item == it.code) {
            arr.push({
              sourceType: 2,
              efficacy: it.code,
              efficacyDesc: it.desc,
            });
          }
        });
      });
      this.form.contentEfficacys = arr;
    },
    // 药品分类
    checkCateGoryLabel(categoryDrugs, index) {
      //判断是否存在当前项，如果存在则取消选中并从数据中删除
      this.form.drugCategories = [];
      let obj = {
        sort: categoryDrugs[index].sort,
        id: categoryDrugs[index].id,
        name: categoryDrugs[index].name,
      };
      this.form.drugCategories.push(obj);
    },
    changeEncyclopediaLabels(data) {
      this.form.contentDrugs = data;
    },
    cancel: function () {
      this.$router.push(`/wikiManage/commonwiki?type=` + this.actionType);
      this.hopStorage();
    },
    blurEditorEvent(editor, index) {
      // 编辑文章不做临时保存操作
      /*if(this.form.contentId){
          return;
        }*/
      if (typeof index === "number") {
        this.paragraphList[index].content = editor.getContent() || "";
      }
      // var tipDom = $(
      //   '<div class="successfully" style="position: absolute; top: 0; right: 15px;color: green;">保存成功</div>'
      // );
      // let ParentElement = $(editor.editorContainer)
      //   .find(".tox-toolbar__group")
      //   .eq(0);
      // let subelement = ParentElement.find(".successfully");
      // // 只创建一次
      // if (subelement.length == 0) {
      //   $(editor.editorContainer)
      //     .find(".tox-toolbar__group")
      //     .eq(0)
      //     .append(tipDom);
      // }
      // clearTimeout(this.tipTimeout);
      // this.tipTimeout = setTimeout(function() {
      //   var DeleteElement = $(".tox-toolbar__group .successfully:eq(0)");
      //   if (DeleteElement) {
      //     DeleteElement.remove();
      //   }
      // }, 500);

      var cacheArticle = this.$commonJs.getArticleDataFromCache(
        this.form.contentId
      );
      if (cacheArticle) {
        this.form.contentParagraphs = cacheArticle.contentParagraphs;
      } else {
        // 如果不存在，则新增一篇文章
        this.paragraphList.forEach((item) => {
          this.form.contentParagraphs.push({
            paragraphStyle: item.style,
            paragraphCode: item.code,
            paragraphName: item.name,
            paragraphType: item.contentType,
            paragraphContent: item.content || "",
          });
        });
      }
      if (typeof index === "number") {
        this.form.contentParagraphs[index].paragraphContent =
          editor.getContent() || "";
      } else {
        this.form.referenceEditorContent = editor.getContent();
      }
      this.$commonJs.setCacheArticleData(this.$commonJs.deepClone(this.form));
    },
    // 恢复段落内容
    restoreContentParagraphs({ editor, index }) {
      var article = this.$commonJs.getArticleDataFromCache(this.form.contentId);
      if (!article) {
        return;
      }
      this.$set(
        this.paragraphList[index],
        "content",
        article.contentParagraphs[index].paragraphContent
      );
      // 参考文献
      this.form.referenceEditorContent = article.referenceEditorContent;
    },
    //初始化获取文章标签和疾病标签
    init() {
      this.user_identity = sessionStorage.getItem("user_identity");
    },

    // 编审医生
    doctor_remoteMethod(query) {
      this.doctorList(query, "doctorOptions", "search_doctor_loading");
    },
    // 编写医生
    write_remoteMethod(query) {
      this.doctorList(query, "writeOptions", "write_doctor_loading");
    },
    writeChange() {
      if (this.writeDoctor == "") {
        this.writeOptions = [];
      }
      if (this.doctor == "") {
        this.doctorOptions = [];
      }
    },
    doctorList(query, str, loadingStr) {
      if (query !== "") {
        this[loadingStr] = true;
        request("health_cmp_listByDoctorName", {
          tenantId: this.$commonJs.getTenantId(),
          doctorName: query,
        })
          .then((res) => {
            this[str] = res;
            this[loadingStr] = false;
          })
          .catch((err) => {
            this[str] = [];
            this[loadingStr] = false;
          });
      } else {
        this[str] = [];
      }
    },

    changeContentSkusLabels(data) {
      console.log("🚀 ~ changeContentSkusLabels ~ data:", data, this.form);
      
      this.form.contentSkus = data;
    },
    //获取文章详情
    getDiseaseInfoDraftDetail(CB) {
      request("health_cmp_queryContentDraftById", {
        contentId: this.form.contentId,
        tenantId: this.$commonJs.getTenantId(),
      })
        .then((res) => {
          console.log("resres", res);
          this.form.contentStatus = res.contentStatus;
          if (res?.authors?.length && res.authors[0].authorType == 6) {
            this.form.authors[0].authorName = res.authors[0].authorName;
          }
          this.form.contentAuditStatus = res.contentAuditStatus;
          // 检查缓存更新时间和最新更新时间确定是否删除缓存
          var cacheArticle = this.$commonJs.getArticleDataFromCache(
            res.contentId
          );
          if (cacheArticle) {
            try {
              var cacheUpdate = new Date(
                cacheArticle.updateTime.replace(/-/g, "/")
              );
              var lastUpdate = new Date(res.updateTime.replace(/-/g, "/"));
              if (lastUpdate.getTime() > cacheUpdate.getTime()) {
                this.$commonJs.removeCacheArticleData(res.contentId);
              }
            } catch (error) {
              console.log(error);
            }
          }
          this.displayInfo(res);
          CB && CB();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 是否跟换名称
    repealclickHandler(val) {
      if (val === "one") {
        this.reset_Diseases = false;
        this.getDiseaseInfoDraftDetail();
      } else if (val === "two") {
        this.reset_Diseases = false;
      }
    },
    filterContentAttrbutes(arr, type) {
      const filterArr = arr.filter((item) => item.type == type);
      return filterArr.length > 0 ? filterArr[0] : {};
    },
    //反显信息
    displayInfo(res) {
      // 反显宠物疾病
      if (
        JSON.stringify(res?.diseaseInfo) != "{}" &&
        this.$route.query.type == 31
      ) {
        this.$refs["petClassify"][0].setPetClassifyCheckList(
          res.diseaseInfo?.categoryCode
        );
        this.categoryCode = res.diseaseInfo?.categoryCode;
      }

      // 反显宠物症状
      if (res?.contentPetSymptoms?.length > 0) {
        this.$refs["petClassify"][0].setPetClassifyCheckList(
          res.contentPetSymptoms?.[0].symptomCategoryCode
        );
        this.form.contentPetSymptoms = res.contentPetSymptoms;
      }

      // 反显易感动物
      if (res?.contentPets?.length > 0) {
        let arr = [];
        res.contentPets.map((item) => arr.push(item.petCategoryCode));
        this.$refs["ContentPetSymptoms"][0].setPetClassifyCheckList(arr);
        this.form.contentPets = res.contentPets;
      }
      console.log("window.location", window.location.pathname);

      // 反显功效
      if (
        res?.contentEfficacys?.length > 0 &&
        window.location.pathname == "/wikiManage/commonwikiEdit"
      ) {
        let arr = [];
        res?.contentEfficacys.map((item) => arr.push(item.efficacy));
        this.$refs["PetEffect"] &&
          this.$refs["PetEffect"][0].setPetClassifyCheckList(arr);
        this.form.contentEfficacys = res.contentEfficacys;
      }

      // 药品分类反显
      if (res?.contentPetMedicines?.length > 0) {
        res?.contentPetMedicines.map((item) => {
          (this.drugCategoryCode = item.drugCategoryCode),
            (this.dosageCode = item.dosageCode),
            (this.rxType = item.rxType);
        });
        this.$refs["PetDrug"][0].setPetClassifyCheckList(this.drugCategoryCode);
        this.$refs["PetDrugType"][0].setPetClassifyCheckList(this.dosageCode);
        this.form.contentPetMedicines = res.contentPetMedicines;
      }

      console.log(
        "contentPetSymptomscontentPetSymptoms",
        res.contentPetSymptoms
      );
      if (res.departments) {
        this.selectedDeparttId = [];
        res.departments.map((item) => {
          if (item.departLevel == 1) {
            this.selectedDeparttId.push([item.departId]);
          } else {
            this.selectedDeparttId.push([item.parentId, item.departId]);
          }
        });
      }
      if (res.contentStatus) {
        this.contentStatus = res.contentStatus;
      }

      this.form.contentSkus = res.contentSkus;
    
      if (res.auditInfo) {
        this.auditInfoShow = res.auditInfo.auditStatus;
      }
      //反显中药作用
      if (res.contentChineseMedicine) {
        this.form.contentChineseMedicine = res.contentChineseMedicine;
        this.contentChineseMedicine = res.contentChineseMedicine.effect || "";
      }
      //反显疾病名称
      if (res.contentName) {
        this.form.contentName = res.contentName;
      }

      // 多图
      console.log("==== 多图", res?.contentPictures);
      this.form.contentPictures = res?.contentPictures || [];

      //项目介绍
      if (res.summary) {
        this.form.summary = res.summary;
      }
      // 返显部位
      if (res.bodyParts) {
        this.symptomsPartsValue = [];
        this.$refs.symptomsPartsRef[0].symptomsParts.map((v) => {
          res.bodyParts.map((item) => {
            if (item.id == v.id) {
              this.symptomsPartsValue.push(item.id);
            }
          });
        });
      }
      //反显关联疾病
      this.form.contentRelations = res.contentRelations || [];
      //反显别名
      if (!res.contentAliasNames) {
        this.form.contentAliasNames = [];
      } else {
        this.form.contentAliasNames = res.contentAliasNames;
      }
      // 反显传染病
      if (res.diseaseInfo) {
        this.form.diseaseInfo = res.diseaseInfo;
      }
      // 反显关联药品
      if (res.contentDrugs) {
        this.form.contentDrugs = res.contentDrugs;
      }
      // 反显药品分类
      this.form.drugCategories = res.drugCategories || [];
      //反显关联疾病
      this.form.contentRelations = res.contentRelations || [];
      if (res.contentAttributes) {
        // 反显处方药 单选 type为9
        this.prescriptionDrug =
          this.filterContentAttrbutes(res.contentAttributes, 9).code || 0;
        // 反显常见药品 单选 type为8
        this.commonDrugs =
          this.filterContentAttrbutes(res.contentAttributes, 8).code || 0;
      }

      // 反显疫苗基本信息
      if (res.contentVaccine) {
        this.$refs.vaccineLabelref[0] &&
          this.$refs.vaccineLabelref[0].setCheckList(
            res.contentVaccine.vaccineCategories.map((item) => item.code)
          );
        this.vaccineCategories = res.contentVaccine.vaccineCategories.map(
          (item) => item.code
        );
        this.form.contentVaccine.vaccinationCount =
          res.contentVaccine.vaccinationCount;
        this.form.contentVaccine.vaccineCategories =
          res.contentVaccine.vaccineCategories.map((item) => item.code);
        this.form.contentVaccine.payType = res.contentVaccine.payType;
      }
      //反显段落
      this.form.contentParagraphs = res.contentParagraphs || [];
      var cache_article = this.$commonJs.getArticleDataFromCache(res.contentId);
      if (!cache_article) {
        var isFirstAdd = this.paragraphList.length == 0;
        res.contentParagraphs &&
          res.contentParagraphs.map((item, index) => {
            if (isFirstAdd) {
              this.paragraphList.push({
                style: item.style || this.paragraphListCategory?.[index]?.style,
                code: item.paragraphCode,
                name:
                  item.paragraphName || this.paragraphListCategory[index].name,
                contentType:
                  item.paragraphType ||
                  this.paragraphListCategory[index].contentType,
                content: item.paragraphContent || "",
              });
            } else {
              let sss =
                this.floorTransferDTOS &&
                this.floorTransferDTOS.find(
                  (q) => q.floorLabelCode === "common-wiki-paragraph"
                );
              let contentParagraphType = [];
              try {
                contentParagraphType = JSON.parse(
                  JSON.parse(
                    sss?.cfgList?.find((q) => q.name === "submit").value
                  ).find((q) => q.name === "contentType").value
                );
              } catch (error) {
                console.log(error);
              }
              this.paragraphList = contentParagraphType.map((val, index) => {
                return {
                  ...this.paragraphList[index],
                  style: val.style,
                  paragraphCode: this.paragraphList[index].code,
                };
              });
              for (var i = 0; i < this.paragraphList.length; i++) {
                if (this.paragraphList[i].code == item.paragraphCode) {
                  this.paragraphList[i].content = item.paragraphContent || "";
                  this.paragraphList[i].style =
                    this.paragraphList[i].style ||
                    item.style ||
                    this.paragraphListCategory[i].style;
                  break;
                }
              }
            }
            try {
              var isEditorInited = setInterval(() => {
                var edd = this.editorList["editor" + index];
                clearInterval(isEditorInited);
                if (edd) {
                  clearInterval(isEditorInited);
                  if (this.paragraphListCategory?.[index]?.style === 1) {
                    edd.setContent(item.paragraphContent || "");
                  }
                }
              }, 300);
            } catch (error) {
              console.log(error);
            }
          });
      }
      // 参考文献
      if (res.references) {
        this.form.referenceEditorContent = res.references;
      }

      // 回显上次保存的标签
      this.form.contentLabels = res.contentLabels || [];
      this.showSelectedLabels();

      // 关键词
      if (res.keywordInfos) {
        this.$nextTick(() => {
          if (this.$refs.keywordsref) {
            this.$refs.keywordsref[0].keywordInfos = [];
            res.keywordInfos &&
              res.keywordInfos.map((item, index) => {
                this.$refs.keywordsref[0].keywordInfos.push(item.keyword);
              });
          }
        });
      }
      // 项目功效
      if (
        res.contentEfficacys &&
        window.location.pathname === "/wikiManage/commonwikiEdit"
      ) {
        this.$nextTick(() => {
          this.$refs.projectEffectivenessRef[0].keywordInfos = [];
          res.contentEfficacys &&
            res.contentEfficacys.map((item, index) => {
              this.$refs.projectEffectivenessRef[0].keywordInfos.push(
                item.efficacy
              );
            });
        });
      }
      this.$nextTick(() => {
        //反显选择疾病
        if (this.$refs.selectDiseaseRef && res.contentDiseases?.length > 0) {
          this.$refs.selectDiseaseRef[0].diseaseOptions = res.contentDiseases;
          this.$refs.selectDiseaseRef[0].diseaseId = res.contentDiseases.map(
            (item) => item.diseaseId
          );
        }
        //反显疾病方向（本期先不做）
        // if (this.$refs.selectDirectionRef) {
        //   this.$refs.selectDirectionRef[0].contentDiseaseDirections = res.contentDiseaseDirections || '';
        // }
        this.form.contentDiseaseDirections = res.contentDiseaseDirections || [];
      });
      this.writeOptions = [];
      this.doctorOptions = [];
      if (res.doctorInfos) {
        res.doctorInfos.map((item) => {
          if (item.roleType == 1) {
            this.writeOptions.push(item);
            this.writeDoctor = item.docId;
          }
        });
      }
      // 编审 编写医生
      if (res.doctorInfos) {
        res.doctorInfos.map((item) => {
          if (item.roleType == 2) {
            this.doctorOptions.push(item);
            this.doctor = item.docId;
          }
        });
      }
    },
    // 回显标签
    showSelectedLabels() {
      if (!this.form.contentLabels || !this.form.contentLabels.length) return;
      if (
        this.$refs.contentLabelref &&
        this.$refs.contentLabelref[0]?.listTenantContentLabels
      ) {
        this.$refs.contentLabelref[0].listTenantContentLabels()?.then(() => {
          for (
            var i = 0;
            i < this.$refs.contentLabelref[0].contentLabels.length;
            i++
          ) {
            var group = this.$refs.contentLabelref[0].contentLabels[i];
            for (var j = 0; j < group.contentLabels.length; j++) {
              var label1 = group.contentLabels[j];
              for (var k = 0; k < this.form.contentLabels.length; k++) {
                var seletedLabel = this.form.contentLabels[k];
                if (label1.id == seletedLabel.id) {
                  this.$set(label1, "isChecked", true);
                  break;
                }
              }
            }
          }
        });
      }
    },
    generateDiseaseId() {
      return (
        "diseaseInfoId_" +
        new Date().getTime() +
        Math.floor(Math.random() * 1000)
      );
    },
    // 删除弹框
    deleteClickHandler(val) {
      if (val === "one") {
        this.deleteForm.deleteDialog = false;
      } else if (val === "two") {
        // 清空contentID
        this.form.contentId = undefined;
        //疾病名称
        this.form.contentName = "";

        // 项目介绍
        this.form.summary = "";

        this.diseaseInfoOptions = [];
        this.selectDiseaseInfoId = "";
        //别名
        this.form.aliasName = "";
        //传染病
        this.infectiousMark = "";
        // 药品分类
        this.form.drugCategories = [];
        //科室
        this.selectedDeparttId = [];
        // 百科属性
        this.form.contentAttributes = [];
        //关联疾病
        this.form.contentRelations = [];
        //段落
        this.paragraphList.map((item, index) => {
          item.content = "";
        });
        //业务标签
        this.$refs.contentLabelref[0].contentLabels = [];
        //关键字
        this.$refs.keywordsref[0].keywordInfos = [];
        this.$refs.projectEffectivenessRef[0].keywordInfos = [];
        this.deleteForm.deleteDialog = false;
      }
    },
    //获取科室信息
    queryDepartments() {
      let params = {
        tenantId: this.$commonJs.getTenantId(),
        contentId: this.form.contentId || "",
      };
      request("health_cmp_queryDepartsWithContentRel", params)
        .then((res) => {
          this.departmentList = res || [];
        })
        .catch((err) => {
          this.departmentList = [];
        });
    },
    // 建议科室
    changeDepartment(val) {
      // 回显赋值
      this.newList = [...this.selectedDeparttId];
      let _val = val.map((item) => {
        return item.toString();
      });
      let _newList = this.newList.map((item) => {
        return item.toString();
      });
      // 删除
      if (this.newList.length > val.length) {
        let remove = _newList.diff(_val);
        this.newList.splice(_newList.indexOf(remove[0]), 1);
      } else {
        // 增加 查找新增项
        let add = _val.diff(_newList);
        this.newList.push(val[_val.indexOf(add[0])]);
      }
      let sss =
        this.floorTransferDTOS &&
        this.floorTransferDTOS.find(
          (q) => q.floorLabelCode === "common-wiki-department"
        );
      let maxLength = JSON.parse(
        JSON.parse(sss.cfgList.find((q) => q.name === "submit").value).find(
          (q) => q.name === "maxLength"
        ).value
      );
      if (this.newList.length > maxLength) {
        this.$message.error("最多选择" + maxLength + "个科室");
        this.newList.pop();
      }
      this.selectedDeparttId = [...this.newList];
    },
    //获取疾病信息
    changeDiseaseLabels(data) {
      // 关联疾病
      this.form.contentRelations = data;
    },
    //获取段落信息
    getContentParagraphDictionary() {
      return new Promise((resolve, reject) => {
        request("health_cmp_queryContentParagraphTypes", {
          contentType: this.actionType, // 1疾病百科，3症状百科, 12是疫苗百科
        })
          .then(async (res) => {
            // this.paragraphListCategory = res || [];
            // this.paragraphList = res || [];
            let sss =
              this.floorTransferDTOS &&
              this.floorTransferDTOS.find(
                (q) => q.floorLabelCode === "common-wiki-paragraph"
              );
            let contentParagraphType = [];
            try {
              contentParagraphType = JSON.parse(
                JSON.parse(
                  sss?.cfgList?.find((q) => q.name === "submit").value
                ).find((q) => q.name === "contentType").value
              );
            } catch (error) {
              console.log(error);
            }
            // 将配置中的style注入
            this.paragraphList = contentParagraphType.map((val, index) => {
              return {
                ...res[index],
                style: val.style,
                paragraphCode: res[index].code,
              };
            });
            this.paragraphListCategory = this.paragraphList;
            await this.getDiseaseInfoDraftDetail();
            resolve(res);
          })
          .catch((err) => {
            this.paragraphListCategory = [];
            this.paragraphList = [];
            reject(err);
          });
      });
    },
    editorReady(data) {
      this.editorList["editor" + data.index] = data.editor;
      this.restoreContentParagraphs(data);
    },
    editorChange(data, index) {
      // element组件特性
      this.$forceUpdate();
    },
    //选中文章标签
    checkArticleLabel(label) {
      this.$set(label, "isChecked", !label.isChecked);

      let arr = this.form.contentLabels || [];
      //判断是否存在当前项，如果存在则取消选中并从数据中删除
      if (!label.isChecked) {
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].id == label.id) {
            this.form.contentLabels.splice(i, 1);
            return false;
          }
        }
      }
      let obj = {
        labelGroupId: label.labelGroupId,
        id: label.id,
        name: label.name,
      };
      this.form.contentLabels.push(obj);
    },
    /**
     * @desc 由于某些特殊字段，无法使用vue v-model绑定操作，需要js手工赋值，故在保存，预览，提交，发布，审核文章前初始化一些表单的数据,比如上传图片，视频等信息
     * @param val  文章状态值 user端：0:第一次创建预览 1:草稿，2:发布，man端：3:保存文章，4:预览，5:通过
     * @param opt_type  user端：caogao:'草稿'，preview:'预览'，fabu:'发布'，man端： shenhe:'审核'，man-preview:'预览'，review:'保存文章'
     */
    initFormBeforeAddOrUpdate(val, opt_type) {
      this.$refs.questionLabel &&
        this.$refs.questionLabel[0].getFormLabelData(this.form);
      this.$refs.labelRef && this.$refs.labelRef[0].getFormLabelData(this.form);
      //根据按钮状态修改articleStatus值 bugfix: 预览接口报异常 预览时 文章状态和草稿状态一致
      this.form.contentName = this.form.contentName.trim();
      this.form.summary = this.form.summary.trim();
      //科室信息
      this.form.departments = [];
      this.selectedDeparttId.map((item) => {
        if (item.length == 1) {
          this.form.departments.push({
            departId: item[0],
          });
        } else {
          this.form.departments.push({
            departId: item[1],
          });
        }
      });
      // 作用
      if (this.contentChineseMedicine) {
        this.form.contentChineseMedicine = {
          effect: this.contentChineseMedicine,
        };
      }
      // 宠物药品
      this.form.contentPetMedicines = [];
      if (
        [0, 1].includes(this.rxType) &&
        this.drugCategoryCode &&
        this.dosageCode
      ) {
        this.form.contentPetMedicines.push({
          drugCategoryCode: this.drugCategoryCode,
          dosageCode: this.dosageCode,
          rxType: Number(this.rxType),
        });
      }
      // 宠物疾病
      if (this.$route.query.articleType == 31) {
        // this.form.diseaseInfo = {};
        this.form.diseaseInfo = {
          ...this.form.diseaseInfo,
          ...{ categoryCode: this.categoryCode },
        };
        console.log("this.form.diseaseInfo", this.form.diseaseInfo);
      }
      // 疫苗分类
      this.form.contentVaccine.vaccineCategories = this.vaccineCategories.map(
        (item) => ({ code: item })
      );
      // 处方药
      this.form.contentAttributes = [];
      if (this.prescriptionDrug !== 0) {
        this.form.contentAttributes.push({
          type: 9,
          code: Number(this.prescriptionDrug),
        });
      }
      this.form.bodyParts = [];
      this.$refs.symptomsPartsRef &&
        this.$refs.symptomsPartsRef[0].symptomsParts.map((item) => {
          this.symptomsPartsValue.map((id) => {
            if (item.id == id) {
              this.form.bodyParts.push(item);
            }
          });
        });
      //获取段落内容
      this.form.contentParagraphs = [];
      if (this.paragraphList.length > 0) {
        console.log(this.paragraphList);
        this.paragraphList.map((item, index) => {
          let paragraphContent = "";
          if (this.editorList["editor" + index]) {
            paragraphContent =
              typeof this.editorList["editor" + index] !== "string"
                ? this.editorList["editor" + index].getContent()
                : this.editorList["editor" + index];
          } else {
            paragraphContent = item.content;
          }
          this.form.contentParagraphs.push({
            style: item.style,
            paragraphCode: item.code,
            paragraphName: item.name,
            paragraphType: item.contentType,
            paragraphContent: paragraphContent || "",
          });
        });
      }

      //关键词
      if (
        this.$refs.keywordsref &&
        this.$refs.keywordsref[0].keywordInfos.length
      ) {
        let arr = [];
        this.$refs.keywordsref[0].keywordInfos.map((item) => {
          arr.push({
            keyword: item,
            keywordType: "1",
          });
        });
        this.form.keywordInfos = arr;
      } else {
        this.form.keywordInfos = [];
      }
      // 项目功效
      if (
        this.$refs.projectEffectivenessRef &&
        this.$refs.projectEffectivenessRef[0].keywordInfos.length
      ) {
        let arr = [];
        this.$refs.projectEffectivenessRef[0].keywordInfos.map((item) => {
          arr.push({
            efficacy: item,
          });
        });
        this.form.contentEfficacys = arr;
      } else if (window.location.pathname != "/wikiManage/commonwikiEdit") {
        this.form.contentEfficacys = [];
      }
      this.form.doctorInfos = [];
      // 编写医生
      this.writeOptions.map((item) => {
        if (this.writeDoctor == item.docId) {
          item.roleType = 1;
          this.form.doctorInfos.push(item);
        }
      });
      // 编审医生
      this.doctorOptions.map((item) => {
        if (this.doctor == item.docId) {
          item.roleType = 2;
          this.form.doctorInfos.push(item);
        }
      });
      this.form.contentStatus = this.contentStatus;
      // 疾病和症状参数
      // contentType 8: 疾病百科 9: 症状百科
      this.form.contentType = Number(this.actionType);
      //选择疾病
      this.form.contentDiseases =
        this.$refs.selectDiseaseRef && this.$refs.selectDiseaseRef[0].diseaseId
          ? this.$refs.selectDiseaseRef[0].diseaseId.map((val) => ({
              diseaseId: val,
            }))
          : [];
      // 疾病方向（本期先不做）
      // this.form.contentDiseaseDirections =
      // this.$refs.selectDirectionRef ? this.$refs.selectDirectionRef[0].contentDiseaseDirections : '';
    },
    /**
     * @desc 保存，预览，提交，发布，审核文章的检查函数
     * @param val  文章状态值 user端：0:第一次创建预览 1:草稿，2:发布，man端：3:保存文章，4:预览，5:通过
     * @param opt_type  user端：caogao:'草稿'，preview:'预览'，fabu:'发布'，man端： shenhe:'审核'，man-preview:'预览'，review:'保存文章'
     * @return true: 表单检查通过， false: ....
     */
    checkBeforeAddOrUpdate(val, opt_type) {
      // 保存文章状态不变
      if (!this.form.contentName || this.form.contentName.trim() == "") {
        this.$message.error("百科名称不能为空");
        return false;
      }
      //别名
      if (
        this.floorTransferDTOS &&
        this.floorTransferDTOS.find(
          (q) => q.floorLabelCode === "common-wiki-alias"
        )
      ) {
        let sss =
          this.floorTransferDTOS &&
          this.floorTransferDTOS.find(
            (q) => q.floorLabelCode === "common-wiki-alias"
          );
        let preview = JSON.parse(
          JSON.parse(sss.cfgList.find((q) => q.name === "preview").value).find(
            (q) => q.name === "isRequired"
          ).value
        );
        let save = JSON.parse(
          JSON.parse(sss.cfgList.find((q) => q.name === "save").value).find(
            (q) => q.name === "isRequired"
          ).value
        );
        let submit = JSON.parse(
          JSON.parse(sss.cfgList.find((q) => q.name === "submit").value).find(
            (q) => q.name === "isRequired"
          ).value
        );
        if (
          val == 0 &&
          (!this.form.contentAuditStatus == 1 ||
            !this.form.contentAuditStatus) &&
          preview == 1
        ) {
          if (this.form.contentAliasNames.length) {
            this.$message.error("别名不能为空");
            return false;
          }
        }
        if (
          val == 2 &&
          (!this.form.contentAuditStatus == 1 ||
            !this.form.contentAuditStatus) &&
          submit == 1
        ) {
          if (this.form.contentAliasNames.length) {
            this.$message.error("别名不能为空");
            return false;
          }
        }
        if (
          val == 1 &&
          (!this.form.contentAuditStatus == 1 ||
            !this.form.contentAuditStatus) &&
          save == 1
        ) {
          if (this.form.contentAliasNames.length) {
            this.$message.error("别名不能为空");
            return false;
          }
        }
      }

      // 分类
      if (
        this.floorTransferDTOS &&
        this.floorTransferDTOS.find(
          (q) => q.floorLabelCode === "common-wiki-classify"
        )
      ) {
        let sss =
          this.floorTransferDTOS &&
          this.floorTransferDTOS.find(
            (q) => q.floorLabelCode === "common-wiki-classify"
          );
        let preview = JSON.parse(
          JSON.parse(sss.cfgList.find((q) => q.name === "preview").value).find(
            (q) => q.name === "isRequired"
          ).value
        );
        let save = JSON.parse(
          JSON.parse(sss.cfgList.find((q) => q.name === "save").value).find(
            (q) => q.name === "isRequired"
          ).value
        );
        let submit = JSON.parse(
          JSON.parse(sss.cfgList.find((q) => q.name === "submit").value).find(
            (q) => q.name === "isRequired"
          ).value
        );
        if (this.$route.query.type == 32) {
          if (
            val == 0 &&
            (!this.form.contentAuditStatus == 1 ||
              !this.form.contentAuditStatus) &&
            preview == 1
          ) {
            if (!this.form.contentPetSymptoms.length) {
              this.$message.error("分类不能为空");
              return false;
            }
          }
          if (
            val == 2 &&
            (!this.form.contentAuditStatus == 1 ||
              !this.form.contentAuditStatus) &&
            submit == 1
          ) {
            if (!this.form.contentPetSymptoms.length) {
              this.$message.error("分类不能为空");
              return false;
            }
          }
          if (
            val == 1 &&
            (!this.form.contentAuditStatus == 1 ||
              !this.form.contentAuditStatus) &&
            save == 1
          ) {
            if (!this.form.contentPetSymptoms.length) {
              this.$message.error("分类不能为空");
              return false;
            }
          }
        } else {
          if (
            val == 0 &&
            (!this.form.contentAuditStatus == 1 ||
              !this.form.contentAuditStatus) &&
            preview == 1
          ) {
            if (!this.categoryCode) {
              this.$message.error("分类不能为空");
              return false;
            }
          }
          if (
            val == 2 &&
            (!this.form.contentAuditStatus == 1 ||
              !this.form.contentAuditStatus) &&
            submit == 1
          ) {
            if (!this.categoryCode) {
              this.$message.error("分类不能为空");
              return false;
            }
          }
          if (
            val == 1 &&
            (!this.form.contentAuditStatus == 1 ||
              !this.form.contentAuditStatus) &&
            save == 1
          ) {
            if (!this.categoryCode) {
              this.$message.error("分类不能为空");
              return false;
            }
          }
        }
      }

      // 易感动物
      if (
        this.floorTransferDTOS &&
        this.floorTransferDTOS.find(
          (q) => q.floorLabelCode === "common-wiki-symptoms"
        )
      ) {
        let sss =
          this.floorTransferDTOS &&
          this.floorTransferDTOS.find(
            (q) => q.floorLabelCode === "common-wiki-symptoms"
          );
        let preview = JSON.parse(
          JSON.parse(sss.cfgList.find((q) => q.name === "preview").value).find(
            (q) => q.name === "isRequired"
          ).value
        );
        let save = JSON.parse(
          JSON.parse(sss.cfgList.find((q) => q.name === "save").value).find(
            (q) => q.name === "isRequired"
          ).value
        );
        let submit = JSON.parse(
          JSON.parse(sss.cfgList.find((q) => q.name === "submit").value).find(
            (q) => q.name === "isRequired"
          ).value
        );
        if (
          val == 0 &&
          (!this.form.contentAuditStatus == 1 ||
            !this.form.contentAuditStatus) &&
          preview == 1
        ) {
          if (!this.form.contentPets.length) {
            this.$message.error("易感动物不能为空");
            return false;
          }
        }
        if (
          val == 2 &&
          (!this.form.contentAuditStatus == 1 ||
            !this.form.contentAuditStatus) &&
          submit == 1
        ) {
          if (!this.form.contentPets.length) {
            this.$message.error("易感动物不能为空");
            return false;
          }
        }
        if (
          val == 1 &&
          (!this.form.contentAuditStatus == 1 ||
            !this.form.contentAuditStatus) &&
          save == 1
        ) {
          if (!this.form.contentPets.length) {
            this.$message.error("易感动物不能为空");
            return false;
          }
        }
      }

      // 宠物药品
      if (
        this.floorTransferDTOS &&
        this.floorTransferDTOS.find(
          (q) => q.floorLabelCode === "common-wiki-petdrug"
        )
      ) {
        let sss =
          this.floorTransferDTOS &&
          this.floorTransferDTOS.find(
            (q) => q.floorLabelCode === "common-wiki-petdrug"
          );
        let preview = JSON.parse(
          JSON.parse(sss.cfgList.find((q) => q.name === "preview").value).find(
            (q) => q.name === "isRequired"
          ).value
        );
        let save = JSON.parse(
          JSON.parse(sss.cfgList.find((q) => q.name === "save").value).find(
            (q) => q.name === "isRequired"
          ).value
        );
        let submit = JSON.parse(
          JSON.parse(sss.cfgList.find((q) => q.name === "submit").value).find(
            (q) => q.name === "isRequired"
          ).value
        );
        if (
          val == 0 &&
          (!this.form.contentAuditStatus == 1 ||
            !this.form.contentAuditStatus) &&
          preview == 1
        ) {
          if (!this.drugCategoryCode) {
            this.$message.error("药品分类不能为空");
            return false;
          }
        }
        if (
          val == 2 &&
          (!this.form.contentAuditStatus == 1 ||
            !this.form.contentAuditStatus) &&
          submit == 1
        ) {
          if (!this.drugCategoryCode) {
            this.$message.error("药品分类不能为空");
            return false;
          }
        }
        if (
          val == 1 &&
          (!this.form.contentAuditStatus == 1 ||
            !this.form.contentAuditStatus) &&
          save == 1
        ) {
          if (!this.drugCategoryCode) {
            this.$message.error("药品分类不能为空");
            return false;
          }
        }
      }

      // 宠物药品剂型
      if (
        this.floorTransferDTOS &&
        this.floorTransferDTOS.find(
          (q) => q.floorLabelCode === "common-wiki-typedrug"
        )
      ) {
        let sss =
          this.floorTransferDTOS &&
          this.floorTransferDTOS.find(
            (q) => q.floorLabelCode === "common-wiki-typedrug"
          );
        let preview = JSON.parse(
          JSON.parse(sss.cfgList.find((q) => q.name === "preview").value).find(
            (q) => q.name === "isRequired"
          ).value
        );
        let save = JSON.parse(
          JSON.parse(sss.cfgList.find((q) => q.name === "save").value).find(
            (q) => q.name === "isRequired"
          ).value
        );
        let submit = JSON.parse(
          JSON.parse(sss.cfgList.find((q) => q.name === "submit").value).find(
            (q) => q.name === "isRequired"
          ).value
        );
        if (
          val == 0 &&
          (!this.form.contentAuditStatus == 1 ||
            !this.form.contentAuditStatus) &&
          preview == 1
        ) {
          if (!this.dosageCode) {
            this.$message.error("剂型不能为空");
            return false;
          }
        }
        if (
          val == 2 &&
          (!this.form.contentAuditStatus == 1 ||
            !this.form.contentAuditStatus) &&
          submit == 1
        ) {
          if (!this.dosageCode) {
            this.$message.error("剂型不能为空");
            return false;
          }
        }
        if (
          val == 1 &&
          (!this.form.contentAuditStatus == 1 ||
            !this.form.contentAuditStatus) &&
          save == 1
        ) {
          if (!this.dosageCode) {
            this.$message.error("剂型不能为空");
            return false;
          }
        }
      }

      // 宠物药品是否处方
      if (
        this.floorTransferDTOS &&
        this.floorTransferDTOS.find(
          (q) => q.floorLabelCode === "common-wiki-isrx"
        )
      ) {
        let sss =
          this.floorTransferDTOS &&
          this.floorTransferDTOS.find(
            (q) => q.floorLabelCode === "common-wiki-isrx"
          );
        let preview = JSON.parse(
          JSON.parse(sss.cfgList.find((q) => q.name === "preview").value).find(
            (q) => q.name === "isRequired"
          ).value
        );
        let save = JSON.parse(
          JSON.parse(sss.cfgList.find((q) => q.name === "save").value).find(
            (q) => q.name === "isRequired"
          ).value
        );
        let submit = JSON.parse(
          JSON.parse(sss.cfgList.find((q) => q.name === "submit").value).find(
            (q) => q.name === "isRequired"
          ).value
        );
        if (
          val == 0 &&
          (!this.form.contentAuditStatus == 1 ||
            !this.form.contentAuditStatus) &&
          preview == 1
        ) {
          if (![0, 1].includes(this.rxType)) {
            this.$message.error("是否处方不能为空");
            return false;
          }
        }
        if (
          val == 2 &&
          (!this.form.contentAuditStatus == 1 ||
            !this.form.contentAuditStatus) &&
          submit == 1
        ) {
          if (![0, 1].includes(this.rxType)) {
            this.$message.error("是否处方不能为空");
            return false;
          }
        }
        if (
          val == 1 &&
          (!this.form.contentAuditStatus == 1 ||
            !this.form.contentAuditStatus) &&
          save == 1
        ) {
          if (![0, 1].includes(this.rxType)) {
            this.$message.error("是否处方不能为空");
            return false;
          }
        }
      }

      // 中药作用
      if (
        this.floorTransferDTOS &&
        this.floorTransferDTOS.find(
          (q) => q.floorLabelCode === "wiki-detail-effect"
        )
      ) {
        let sss =
          this.floorTransferDTOS &&
          this.floorTransferDTOS.find(
            (q) => q.floorLabelCode === "wiki-detail-effect"
          );
        let preview = JSON.parse(
          JSON.parse(sss.cfgList.find((q) => q.name === "preview").value).find(
            (q) => q.name === "isRequired"
          ).value
        );
        let save = JSON.parse(
          JSON.parse(sss.cfgList.find((q) => q.name === "save").value).find(
            (q) => q.name === "isRequired"
          ).value
        );
        let submit = JSON.parse(
          JSON.parse(sss.cfgList.find((q) => q.name === "submit").value).find(
            (q) => q.name === "isRequired"
          ).value
        );
        if (
          val == 0 &&
          (!this.form.contentAuditStatus == 1 ||
            !this.form.contentAuditStatus) &&
          preview == 1
        ) {
          if (!this.form.contentChineseMedicine) {
            this.$message.error("作用不能为空");
            return false;
          }
        }
        if (
          val == 2 &&
          (!this.form.contentAuditStatus == 1 ||
            !this.form.contentAuditStatus) &&
          submit == 1
        ) {
          if (!this.form.contentChineseMedicine) {
            this.$message.error("作用不能为空");
            return false;
          }
        }
        if (
          val == 1 &&
          (!this.form.contentAuditStatus == 1 ||
            !this.form.contentAuditStatus) &&
          save == 1
        ) {
          if (!this.form.contentChineseMedicine) {
            this.$message.error("作用不能为空");
            return false;
          }
        }
      }
      // 传染病
      if (
        this.floorTransferDTOS &&
        this.floorTransferDTOS.find(
          (q) => q.floorLabelCode === "common-wiki-infectious"
        )
      ) {
        let sss =
          this.floorTransferDTOS &&
          this.floorTransferDTOS.find(
            (q) => q.floorLabelCode === "common-wiki-infectious"
          );
        let preview = JSON.parse(
          JSON.parse(sss.cfgList.find((q) => q.name === "preview").value).find(
            (q) => q.name === "isRequired"
          ).value
        );
        let save = JSON.parse(
          JSON.parse(sss.cfgList.find((q) => q.name === "save").value).find(
            (q) => q.name === "isRequired"
          ).value
        );
        let submit = JSON.parse(
          JSON.parse(sss.cfgList.find((q) => q.name === "submit").value).find(
            (q) => q.name === "isRequired"
          ).value
        );
        if (
          val == 0 &&
          (!this.form.contentAuditStatus == 1 ||
            !this.form.contentAuditStatus) &&
          preview == 1
        ) {
          if (
            this.form.diseaseInfo.infectiousMark != 1 &&
            this.form.diseaseInfo.infectiousMark != 0
          ) {
            this.$message.error("请确认是否为传染病");
            return false;
          }
        }
        if (
          val == 2 &&
          (!this.form.contentAuditStatus == 1 ||
            !this.form.contentAuditStatus) &&
          submit == 1
        ) {
          if (
            this.form.diseaseInfo.infectiousMark != 1 &&
            this.form.diseaseInfo.infectiousMark != 0
          ) {
            this.$message.error("请确认是否为传染病");
            return false;
          }
        }
        if (
          val == 1 &&
          (!this.form.contentAuditStatus == 1 ||
            !this.form.contentAuditStatus) &&
          save == 1
        ) {
          if (
            this.form.diseaseInfo.infectiousMark != 1 &&
            this.form.diseaseInfo.infectiousMark != 0
          ) {
            this.$message.error("请确认是否为传染病");
            return false;
          }
        }
      }

      // 疫苗分类
      if (
        this.floorTransferDTOS &&
        this.floorTransferDTOS.find(
          (q) => q.floorLabelCode === "common-wiki-vaccine-category"
        )
      ) {
        let sss =
          this.floorTransferDTOS &&
          this.floorTransferDTOS.find(
            (q) => q.floorLabelCode === "common-wiki-vaccine-category"
          );
        let preview = JSON.parse(
          JSON.parse(sss.cfgList.find((q) => q.name === "preview").value).find(
            (q) => q.name === "isRequired"
          ).value
        );
        let save = JSON.parse(
          JSON.parse(sss.cfgList.find((q) => q.name === "save").value).find(
            (q) => q.name === "isRequired"
          ).value
        );
        let submit = JSON.parse(
          JSON.parse(sss.cfgList.find((q) => q.name === "submit").value).find(
            (q) => q.name === "isRequired"
          ).value
        );
        if (
          val == 0 &&
          (!this.form.contentAuditStatus == 1 ||
            !this.form.contentAuditStatus) &&
          preview == 1
        ) {
          if (this.form.contentVaccine.vaccineCategories.length === 0) {
            this.$message.error("疫苗分类不能为空");
            return false;
          }
        }
        if (
          val == 2 &&
          (!this.form.contentAuditStatus == 1 ||
            !this.form.contentAuditStatus) &&
          submit == 1
        ) {
          if (this.form.contentVaccine.vaccineCategories.length === 0) {
            this.$message.error("疫苗分类不能为空");
            return false;
          }
        }
        if (
          val == 1 &&
          (!this.form.contentAuditStatus == 1 ||
            !this.form.contentAuditStatus) &&
          save == 1
        ) {
          if (this.form.contentVaccine.vaccineCategories.length === 0) {
            this.$message.error("疫苗分类不能为空");
            return false;
          }
        }
      }
      // 药品分类
      if (
        this.floorTransferDTOS &&
        this.floorTransferDTOS.find(
          (q) => q.floorLabelCode === "common-wiki-category"
        )
      ) {
        let sss =
          this.floorTransferDTOS &&
          this.floorTransferDTOS.find(
            (q) => q.floorLabelCode === "common-wiki-category"
          );
        let preview = JSON.parse(
          JSON.parse(sss.cfgList.find((q) => q.name === "preview").value).find(
            (q) => q.name === "isRequired"
          ).value
        );
        let save = JSON.parse(
          JSON.parse(sss.cfgList.find((q) => q.name === "save").value).find(
            (q) => q.name === "isRequired"
          ).value
        );
        let submit = JSON.parse(
          JSON.parse(sss.cfgList.find((q) => q.name === "submit").value).find(
            (q) => q.name === "isRequired"
          ).value
        );
        console.log(this.form.drugCategories, 9999);
        if (
          val == 0 &&
          (!this.form.contentAuditStatus == 1 ||
            !this.form.contentAuditStatus) &&
          preview == 1
        ) {
          if (
            !this.form.drugCategories ||
            this.form.drugCategories.length == 0
          ) {
            this.$message.error("药品分类不能为空");
            return false;
          }
        }
        if (
          val == 2 &&
          (!this.form.contentAuditStatus == 1 ||
            !this.form.contentAuditStatus) &&
          submit == 1
        ) {
          if (
            !this.form.drugCategories ||
            this.form.drugCategories.length == 0
          ) {
            this.$message.error("药品分类不能为空");
            return false;
          }
        }
        if (
          val == 1 &&
          (!this.form.contentAuditStatus == 1 ||
            !this.form.contentAuditStatus) &&
          save == 1
        ) {
          if (
            !this.form.drugCategories ||
            this.form.drugCategories.length == 0
          ) {
            this.$message.error("药品分类不能为空");
            return false;
          }
        }
      }
      // 选择疾病
      if (
        this.floorTransferDTOS &&
        this.floorTransferDTOS.find(
          (q) => q.floorLabelCode === "common-wiki-select-disease"
        )
      ) {
        let sss =
          this.floorTransferDTOS &&
          this.floorTransferDTOS.find(
            (q) => q.floorLabelCode === "common-wiki-select-disease"
          );
        let preview = JSON.parse(
          JSON.parse(sss.cfgList.find((q) => q.name === "preview").value).find(
            (q) => q.name === "isRequired"
          ).value
        );
        let save = JSON.parse(
          JSON.parse(sss.cfgList.find((q) => q.name === "save").value).find(
            (q) => q.name === "isRequired"
          ).value
        );
        let submit = JSON.parse(
          JSON.parse(sss.cfgList.find((q) => q.name === "submit").value).find(
            (q) => q.name === "isRequired"
          ).value
        );
        if (
          val == 0 &&
          (!this.form.contentAuditStatus == 1 ||
            !this.form.contentAuditStatus) &&
          preview == 1
        ) {
          if (this.form.contentDiseases.length) {
            this.$message.error("选择疾病不能为空");
            return false;
          }
        }
        if (
          val == 2 &&
          (!this.form.contentAuditStatus == 1 ||
            !this.form.contentAuditStatus) &&
          submit == 1
        ) {
          if (this.form.contentDiseases.length) {
            this.$message.error("选择疾病不能为空");
            return false;
          }
        }
        if (
          val == 1 &&
          (!this.form.contentAuditStatus == 1 ||
            !this.form.contentAuditStatus) &&
          save == 1
        ) {
          if (this.form.contentDiseases.length) {
            this.$message.error("选择疾病不能为空");
            return false;
          }
        }
      }
      // 部位
      if (
        this.floorTransferDTOS &&
        this.floorTransferDTOS.find(
          (q) => q.floorLabelCode === "common-wiki-select-location"
        )
      ) {
        let sss =
          this.floorTransferDTOS &&
          this.floorTransferDTOS.find(
            (q) => q.floorLabelCode === "common-wiki-select-location"
          );
        let preview = JSON.parse(
          JSON.parse(sss.cfgList.find((q) => q.name === "preview").value).find(
            (q) => q.name === "isRequired"
          ).value
        );
        let save = JSON.parse(
          JSON.parse(sss.cfgList.find((q) => q.name === "save").value).find(
            (q) => q.name === "isRequired"
          ).value
        );
        let submit = JSON.parse(
          JSON.parse(sss.cfgList.find((q) => q.name === "submit").value).find(
            (q) => q.name === "isRequired"
          ).value
        );
        if (
          val == 0 &&
          (!this.form.contentAuditStatus == 1 ||
            !this.form.contentAuditStatus) &&
          preview == 1
        ) {
          if (this.symptomsPartsValue == "") {
            this.$message.error("部位不能为空");
            return false;
          }
        }
        if (
          val == 2 &&
          (!this.form.contentAuditStatus == 1 ||
            !this.form.contentAuditStatus) &&
          submit == 1
        ) {
          if (this.symptomsPartsValue == "") {
            this.$message.error("部位不能为空");
            return false;
          }
        }
        if (
          val == 1 &&
          (!this.form.contentAuditStatus == 1 ||
            !this.form.contentAuditStatus) &&
          save == 1
        ) {
          if (this.symptomsPartsValue == "") {
            this.$message.error("部位不能为空");
            return false;
          }
        }
      }
      // 项目介绍
      if (
        this.floorTransferDTOS &&
        this.floorTransferDTOS.find(
          (q) => q.floorLabelCode === "common-wiki-project-introduction"
        )
      ) {
        let sss =
          this.floorTransferDTOS &&
          this.floorTransferDTOS.find(
            (q) => q.floorLabelCode === "common-wiki-project-introduction"
          );
        let preview = JSON.parse(
          JSON.parse(sss.cfgList.find((q) => q.name === "preview").value).find(
            (q) => q.name === "isRequired"
          ).value
        );
        let save = JSON.parse(
          JSON.parse(sss.cfgList.find((q) => q.name === "save").value).find(
            (q) => q.name === "isRequired"
          ).value
        );
        let submit = JSON.parse(
          JSON.parse(sss.cfgList.find((q) => q.name === "submit").value).find(
            (q) => q.name === "isRequired"
          ).value
        );
        if (
          val == 0 &&
          (!this.form.contentAuditStatus == 1 ||
            !this.form.contentAuditStatus) &&
          preview == 1
        ) {
          if (!this.form.summary || this.form.summary.trim() == "") {
            this.$message.error("项目介绍不能为空");
            return false;
          }
        }
        if (
          val == 2 &&
          (!this.form.contentAuditStatus == 1 ||
            !this.form.contentAuditStatus) &&
          submit == 1
        ) {
          if (!this.form.summary || this.form.summary.trim() == "") {
            this.$message.error("项目介绍不能为空");
            return false;
          }
        }
        if (
          val == 1 &&
          (!this.form.contentAuditStatus == 1 ||
            !this.form.contentAuditStatus) &&
          save == 1
        ) {
          if (!this.form.summary || this.form.summary.trim() == "") {
            this.$message.error("项目介绍不能为空");
            return false;
          }
        }
      }
      // 项目功效
      if (
        this.floorTransferDTOS &&
        this.floorTransferDTOS.find(
          (q) => q.floorLabelCode === "common-wiki-project-effectiveness"
        )
      ) {
        let sss =
          this.floorTransferDTOS &&
          this.floorTransferDTOS.find(
            (q) => q.floorLabelCode === "common-wiki-project-effectiveness"
          );
        let preview = JSON.parse(
          JSON.parse(sss.cfgList.find((q) => q.name === "preview").value).find(
            (q) => q.name === "isRequired"
          ).value
        );
        let save = JSON.parse(
          JSON.parse(sss.cfgList.find((q) => q.name === "save").value).find(
            (q) => q.name === "isRequired"
          ).value
        );
        let submit = JSON.parse(
          JSON.parse(sss.cfgList.find((q) => q.name === "submit").value).find(
            (q) => q.name === "isRequired"
          ).value
        );
        if (
          val == 0 &&
          (!this.form.contentAuditStatus == 1 ||
            !this.form.contentAuditStatus) &&
          preview == 1
        ) {
          if (!this.form.contentEfficacys.length) {
            this.$message.error("功效不能为空");
            return false;
          }
        }
        if (
          val == 2 &&
          (!this.form.contentAuditStatus == 1 ||
            !this.form.contentAuditStatus) &&
          submit == 1
        ) {
          if (!this.form.contentEfficacys.length) {
            this.$message.error("功效不能为空");
            return false;
          }
        }
        if (
          val == 1 &&
          (!this.form.contentAuditStatus == 1 ||
            !this.form.contentAuditStatus) &&
          save == 1
        ) {
          if (!this.form.contentEfficacys.length) {
            this.$message.error("功效不能为空");
            return false;
          }
        }
      }
      // 项目段落
      if (
        this.floorTransferDTOS &&
        this.floorTransferDTOS.find(
          (q) => q.floorLabelCode === "common-wiki-paragraph"
        )
      ) {
        let sss =
          this.floorTransferDTOS &&
          this.floorTransferDTOS.find(
            (q) => q.floorLabelCode === "common-wiki-paragraph"
          );
        let preview = JSON.parse(
          JSON.parse(sss.cfgList.find((q) => q.name === "preview").value).find(
            (q) => q.name === "isRequired"
          ).value
        );
        let save = JSON.parse(
          JSON.parse(sss.cfgList.find((q) => q.name === "save").value).find(
            (q) => q.name === "isRequired"
          ).value
        );
        let submit = JSON.parse(
          JSON.parse(sss.cfgList.find((q) => q.name === "submit").value).find(
            (q) => q.name === "isRequired"
          ).value
        );
        if (
          val == 0 &&
          (!this.form.contentAuditStatus == 1 ||
            !this.form.contentAuditStatus) &&
          preview == 1
        ) {
          // 段落至少有一项
          // eslint-disable-next-line no-case-declarations
          let isParagraphsPass = [];
          // eslint-disable-next-line no-case-declarations
          let paragraphsText = [];
          isParagraphsPass = this.form.contentParagraphs.filter((item) => {
            if (item.style === 1 && item.paragraphContent == "") {
              paragraphsText.push(item.paragraphName);
            } else if (item.style === 2 && item.paragraphContent == "") {
              paragraphsText.push(item.paragraphName);
            }
            return (
              (item.style === 1 || item.style === 2) &&
              item.paragraphContent != ""
            );
          });
          if (isParagraphsPass.length < 1) {
            this.$message.error(paragraphsText.join(",") + "至少填写一项");
            return false;
          }
        }
        if (
          val == 2 &&
          (!this.form.contentAuditStatus == 1 ||
            !this.form.contentAuditStatus) &&
          submit == 1
        ) {
          console.log("submit--- 2766", this.form);
          // 段落至少有一项
          // eslint-disable-next-line no-case-declarations
          let isParagraphsPass = [];
          // eslint-disable-next-line no-case-declarations
          let paragraphsText = [];
          isParagraphsPass = this.form.contentParagraphs.filter((item) => {
            if (item.style === 1 && item.paragraphContent == "") {
              paragraphsText.push(item.paragraphName);
            } else if (item.style === 2 && item.paragraphContent == "") {
              paragraphsText.push(item.paragraphName);
            }
            return (
              (item.style === 1 || item.style === 2) &&
              item.paragraphContent != ""
            );
          });
          if (isParagraphsPass.length < 1) {
            this.$message.error(paragraphsText.join(",") + "至少填写一项");
            return false;
          }
        }
        if (
          val == 1 &&
          (!this.form.contentAuditStatus == 1 ||
            !this.form.contentAuditStatus) &&
          save == 1
        ) {
          // 段落至少有一项
          // eslint-disable-next-line no-case-declarations
          let isParagraphsPass = [];
          // eslint-disable-next-line no-case-declarations
          let paragraphsText = [];
          isParagraphsPass = this.form.contentParagraphs.filter((item) => {
            if (item.style === 1 && item.paragraphContent == "") {
              paragraphsText.push(item.paragraphName);
            } else if (item.style === 2 && item.paragraphContent == "") {
              paragraphsText.push(item.paragraphName);
            }
            return (
              (item.style === 1 || item.style === 2) &&
              item.paragraphContent != ""
            );
          });
          if (isParagraphsPass.length < 1) {
            this.$message.error(paragraphsText.join(",") + "至少填写一项");
            return false;
          }
        }
      }
      // 关键词
      if (
        this.floorTransferDTOS &&
        this.floorTransferDTOS.find(
          (q) => q.floorLabelCode === "common-wiki-key-word"
        )
      ) {
        let sss =
          this.floorTransferDTOS &&
          this.floorTransferDTOS.find(
            (q) => q.floorLabelCode === "common-wiki-key-word"
          );
        let preview = JSON.parse(
          JSON.parse(sss.cfgList.find((q) => q.name === "preview").value).find(
            (q) => q.name === "isRequired"
          ).value
        );
        let save = JSON.parse(
          JSON.parse(sss.cfgList.find((q) => q.name === "save").value).find(
            (q) => q.name === "isRequired"
          ).value
        );
        let submit = JSON.parse(
          JSON.parse(sss.cfgList.find((q) => q.name === "submit").value).find(
            (q) => q.name === "isRequired"
          ).value
        );
        if (
          val == 0 &&
          (!this.form.contentAuditStatus == 1 ||
            !this.form.contentAuditStatus) &&
          preview == 1
        ) {
          if (!this.form.keywordInfos.length) {
            this.$message.error("关键词不能为空");
            return false;
          }
        }
        if (
          val == 2 &&
          (!this.form.contentAuditStatus == 1 ||
            !this.form.contentAuditStatus) &&
          submit == 1
        ) {
          if (!this.form.keywordInfos.length) {
            this.$message.error("关键词不能为空");
            return false;
          }
        }
        if (
          val == 1 &&
          (!this.form.contentAuditStatus == 1 ||
            !this.form.contentAuditStatus) &&
          save == 1
        ) {
          if (!this.form.keywordInfos.length) {
            this.$message.error("关键词不能为空");
            return false;
          }
        }
      }
      return true;
    },
    // man-审核
    manOrUpdateDiseaseInfo(val, type) {
      this.initFormBeforeAddOrUpdate(val, type);
      if (!this.checkBeforeAddOrUpdate(val, type)) {
        return;
      }
      if (!utils.copyPictureCheck(this.form.contentParagraphs, this)) return;
      if (val == 0) {
        this.form.scene = "preview";
      } else if (val == 1) {
        this.form.scene = "save";
      } else if (val == 2) {
        this.form.scene = "submit";
      }
      this.form.route =
        "manDetails" + this.actionType || this.$route.query.type;
      let params = this.$commonJs.deepClone(this.form);
      if (params?.authors?.length > 0 && !params.authors[0].authorName) {
        params.authors = [];
      }
      const labels =
        this.$route.query.type == 37 || this.$route.query.type == 42
          ? this.form.extensionContentLabels
          : this.form.contentLabels;
      params.contentLabels = [...(labels || [])];
      // console.log("params", params);
      params.references = this.form.referenceEditorContent;
      // return;
      request("health_cmp_man_updateContent", params)
        .then((res) => {
          let contentIds = {
            contentId: this.form.contentId,
            tenantId: this.$commonJs.getTenantId(),
          };
          if (type == "manPreview") {
            this.articlePreview(contentIds);
          }
          // 保存
          if (type == "save") {
            this.$message.success("保存成功");
          } else if (type == "through") {
            params.auditInfo = { auditStatus: 3 };
            // 审核
            request("health_cmp_manPassContent", contentIds)
              .then((res) => {
                if (res.code === "0000" && !res.data) {
                  this.$message.error("操作失败");
                  return;
                }
                this.$message.success("审核通过");
                this.$router.push(
                  `/wikiManage/commonwiki?type=${this.actionType}`
                );
                this.hopStorage();
              })
              .catch((err) => {
                this.$message.error(err.msg || "审核失败");
              });
          } else if (type == "manSubmit") {
            params.auditInfo = { auditStatus: 2 };
            request("health_cmp_manPublishContent", contentIds)
              .then((res) => {
                if (res) {
                  this.$router.push(
                    `/wikiManage/commonwiki?type=` + this.actionType
                  );
                  this.hopStorage();
                }
                this.$message.success("提交成功");
              })
              .catch((err) => {
                this.$message.error(err.msg + "发布失败");
              });
          }
        })
        .catch((error) => {
          this.$message.error(error.msg || "操作失败！");
        });
    },
    hopStorage() {
      // 跳转列表页存储状态
      sessionStorage.setItem("commonwiki" + this.actionType, 1);
    },
    // 预览
    articlePreview(val) {
      this.dialogPreVisible = true;
      this.previewDialog = true;
      this.jumpUrl("preview/", val.contentId);
    },
    jumpUrl(type, urlId) {
      let isDev = process.env.VUE_APP_BASEURL == "//beta-api.m.jd.com";
      const croute = this.$route.query.croute;
      let preview = "https://cont-yf.healthjd.com/wiki/"; // 疫苗预发地址
      let online = "https://cont.healthjd.com/wiki/"; // 线上疫苗
      let newUrl = `${isDev ? preview : online}${croute}/${type}${urlId}${
        type === "preview/" ? "-man" : ""
      }`;
      this.mUrl = newUrl;
      getQRCode(newUrl, (url) => {
        this.qrCode = url;
        this.dialogPreVisible = true;
      });
    },
    //审核--驳回
    rejectClick() {
      this.rejectForm.rejectlineDialog = true;
    },
    rejectClickHandler(arg) {
      if (arg === "two") {
        if (this.rejectForm.rejectReasons === "") {
          this.$message.error("驳回理由不能为空");
        } else {
          //contentAuditStatus:1草稿、2待审核、3审核通过、4驳回 9撤销投稿
          request("health_cmp_manRejectContent", {
            contentId: this.form.contentId,
            tenantId: this.$commonJs.getTenantId(),
            remark: this.rejectForm.rejectReasons,
          })
            .then((res) => {
              this.rejectForm.rejectlineDialog = false;
              this.rejectForm.rejectReasons = ""; //置空驳回原因
              this.$message.success("驳回成功");
              this.hopStorage();
              this.$router.push(
                `/wikiManage/commonwiki?type=` + this.actionType
              );
            })
            .catch((err) => {
              this.$message.error(err.msg || "发布失败");
            });
        }
      } else {
        this.rejectForm.rejectlineDialog = false;
      }
    },
    checkoutVaccineLabel(vaccineCategories) {
      this.form.contentVaccine.vaccineCategories = vaccineCategories;
    },
    viewImage(url) {
      this.currentImageUrl = url;
      this.dialogVisible = true;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/styles/article_common.scss";
.Editorandreviewer {
  display: flex;
  margin-top: 20px;
  span {
    width: 107px;
    text-align: right;
    margin-right: 10px;
    -ms-flex-negative: 0;
    flex-shrink: 0;
    font-size: 14px;
    color: #2c3443;
  }
  .el-input {
    width: 518px;
    :deep(.el-input__inner) {
      height: 32px !important;
    }
  }
}
.article {
  @include article_common;
  .item-video-wrap {
    border: 1px solid #c0c4cc;
  }
  :deep(.el-form-item) {
    margin-bottom: 22px;
  }
  :deep(.el-textarea__inner) {
    resize: none;
    overflow: hidden;
    overflow-y: auto;
    display: inline-block;
    margin-bottom: 45px;
    margin-right: 15px;
    height: 92px;
  }
  :deep(.el-dialog__body) {
    padding: 30px 26px 0px 26px !important;
  }

  :deep(.content-item p) {
    width: 107px;
    text-align: right;
    margin-right: 10px;
    flex-shrink: 0;
  }

  .el-button {
    line-height: 10px;
  }

  .article_tit {
    .el-input__suffix {
      left: 100% !important;
      right: auto !important;
    }
  }
  // 表单Item样式
  .wrap .content-item .content-item-label {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
}
.finish-buttons {
  width: 307px;
  height: 32px !important;
  margin-top: 62px;
  margin-left: 61px;
}
.article .wrap .writeDoc .el-input {
  width: 645px !important;
}
.content-item.textArea-flex {
  :deep(.el-textarea__inner) {
    margin-bottom: 0;
  }
}
.department-item {
  font-size: 14px;
  color: #2c3443;
  margin-top: 20px;
  position: relative;
  width: 50%;

  p {
    width: 107px;
    text-align: right;
    margin-right: 10px;
    flex-shrink: 0;
    line-height: 32px;
    span {
      color: #f62458;
      margin-right: 5px;
    }
  }
}
.image-container {
  margin: 20px 0;
  width: 100%;
}
.image-flex {
  display: flex;
  flex-wrap: wrap;
  /* 自动换行 */
  gap: 10px;
  /* 图片间距 */
}

.image-item {
  position: relative;
  width: calc(10% - 10px);
  /* 每行3个，减去间距 */
  height: 100px;
  /* 设置图片容器高度 */
  overflow: hidden;
  margin-bottom: 10px;
  /* 图片之间的垂直间距 */
}

.image-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  /* 图片覆盖容器 */
  cursor: pointer;
}

.image-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.5);
  opacity: 0;
  transition: opacity 0.3s;
}

.image-item:hover .image-overlay {
  opacity: 1;
}

.image-overlay .el-button {
  margin: 0 5px;
}
</style>
